export default __webpack_public_path__ + "static/media/people_type_three_active.481ccb41.svg";